import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { OutletService } from '../outlet/outlet.service';
import { ToastrService } from '../notification/toastr.service';
import { PlatformService } from '@core/services/util/platform.service';
import { environment } from '@environment';

@Injectable({
    providedIn: 'root'
})
export class OutletResolver {
    constructor(
        private router: Router,
        private toastrService: ToastrService,
        private outletService: OutletService,
        private platformService: PlatformService
    ) {}

    resolve() {
        if (this.platformService.isServer()) {
            return;
        }
        const brand_id: any = environment.brand.id;
        const outletData = this.outletService.getOutletData(brand_id) as any;

        return new Promise(resolve => {
            outletData.then(data => {
                if (!data?.outlet) {
                    this.router.navigateByUrl('/');
                    window.history.replaceState({}, '', '/');
                    this.toastrService.openSnackBar('Something went wrong. Please try again!', 'OKAY');
                } else {
                    return resolve(data);
                }
            });
        });
    }
}
